<script setup lang="ts">

import { ref } from "vue";
import type { IOfferTile } from "@domain/Marketplace";

type Props = {
    offers: IOfferTile[]
};

const { offers = [] } = defineProps<Props>();
const emit = defineEmits( [ 'on-select' ] );

const active = ref();

</script>

<template>

    <div>
        <v-carousel :show-arrows="false"
                    v-model="active"
                    color="white"
                    class="w-full !h-36 3xl:!h-48 "
                    :cycle="true"
                    :continuous="true"
                    :hide-delimiters="true">
            <div class="rounded-xl overflow-hidden">
                <v-carousel-item v-for="(offer,i) in offers"
                                 :key="i"
                                 class="w-full h-auto">
                    <img :src="offer.featureCoverImageUrl" 
                         class="w-full h-auto cursor-pointer"
                         @click="() => emit( 'on-select', offer )" />
                </v-carousel-item>
            </div>

        </v-carousel>

        <div class="flex justify-center items-center gap-x-6 pt-1 pb-2">
            <button v-for="(offer,i) in offers"
                    class="py-4 px-1.5"
                    @click="active = i">
                <div class="bg-white rounded-full w-2.5 h-2.5 opacity-50"
                     :class="{ '!opacity-100 ring-[8px] ring-white/20': i == active }">
                </div>
            </button>
        </div>

    </div>
    
</template>